import { baseApi } from "../baseApi";
import {
  CompleteYouthProfileRequest,
  CompleteYouthProfileResponse,
  ForgotPasswordRequest,
  ForgotPasswordResponse,
  LoginRequest,
  LoginResponse,
  ResendRequest,
  ResendResponse,
  ResetPasswordRequest,
  ResetPasswordResponse,
  SignupRequest,
  SignupResponse,
  SubmitYouthOnboardingRequest,
  SubmitYouthOnboardingResponse,
  VerifyOtpRequest,
  VerifyOtpResponse,
  YouthOnboardingResponse
} from "./type";

export const authApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    signup: build.mutation<SignupResponse, SignupRequest>({
      query: (body) => ({
        url: "/auth/signup",
        method: "POST",
        body,
      }),
    }),
    verifyOtp: build.mutation<VerifyOtpResponse, VerifyOtpRequest>({
      query: (body) => ({
        url: "/auth/confirm-signup",
        method: "POST",
        body,
      }),
    }),
    resendConfirmation: build.mutation<ResendResponse, ResendRequest>({
      query: (body) => ({
        url: "/auth/resend-confirmation",
        method: "POST",
        body,
      }),
    }),
    forgotPassword: build.mutation<
      ForgotPasswordResponse,
      ForgotPasswordRequest
    >({
      query: (body) => ({
        url: "/auth/forgot-password",
        method: "POST",
        body,
      }),
    }),
    resetPassword: build.mutation<ResetPasswordResponse, ResetPasswordRequest>({
      query: (body) => ({
        url: "/auth/reset-password",
        method: "POST",
        body,
      }),
    }),
    login: build.mutation<LoginResponse, LoginRequest>({
      query: (body) => ({
        url: "/auth/login",
        method: "POST",
        body,
      }),
    }),
    getYouthOnboarding: build.query<YouthOnboardingResponse, void>({
      query: () => ({
        url: "/youth/onboarding",
        method: "GET",
      }),
    }),
    submitYouthOnboarding: build.mutation<
      SubmitYouthOnboardingResponse,
      SubmitYouthOnboardingRequest
    >({
      query: (body) => ({
        url: "/youth/onboarding",
        method: "POST",
        body,
      }),
    }),
    completeYouthProfile: build.mutation<
      CompleteYouthProfileResponse,
      CompleteYouthProfileRequest
    >({
      query: (body) => ({
        url: "/youth/profile/complete",
        method: "PATCH",
        body,
      }),
    }),

    getGoogleLink: build.query<{ authUrl: string }, void>({
      query: () => ({
        url: "/auth/login/google",
        method: "GET",
        params: {
          role: "youth",
        },
      }),
    }),

    getGoogleCallback: build.query<any, { code: string; state?: string }>({
      query: ({ code, state }) => ({
        url: "/auth/google/callback",
        method: "GET",
        params: {
          code,
          state,
        },
      }),
    }),

     getAllDistricts: build.query<any, void>({
      query: () => ({
        url: "/youth/all-districts",
        method: "GET",
      }),
    }),

     getDistrictDetails: build.query<any, string>({
      query: (id) => ({
        url: `/youth/district-details/${id}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useSignupMutation,
  useVerifyOtpMutation,
  useResendConfirmationMutation,
  useForgotPasswordMutation,
  useResetPasswordMutation,
  useLoginMutation,
  useGetYouthOnboardingQuery,
  useSubmitYouthOnboardingMutation,
  useCompleteYouthProfileMutation,
  useGetGoogleLinkQuery,
  useLazyGetGoogleLinkQuery,
  useGetGoogleCallbackQuery,
  useLazyGetGoogleCallbackQuery,
  useGetAllDistrictsQuery,
  useGetDistrictDetailsQuery
} = authApi;
